import { axiosInstance } from "../../../utils/AxiosInstance/AxiosInstance";


let baseRouteAdminInvoice = '/api/v2/admin/masters';


export const createUpdateOrganizationSetup = async (organizationData) => {
    try {
        const response = await axiosInstance.post(`${baseRouteAdminInvoice}/organization`, organizationData);
        return response.data;

    } catch (error) {
        throw new Error('Failed to create or update organization setup', error);
    }
}
export const getAllBillingAddress = async () => {
    try {
        const response = await axiosInstance.get(`${baseRouteAdminInvoice}/get-all-billing-address`);
        return response.data;

    } catch (error) {
        throw new Error('Failed to get billing data', error);
    }
}


export const deleteOrganzationLogo = async (type) => {
    try {
        const response = await axiosInstance.delete(`${baseRouteAdminInvoice}/organization-logo?type=${type}`);
        return response.data;

    } catch (error) {
        throw new Error('Failed to create or update organization setup');
    }
};


export const checkIfAdmin = async (id) => {
    try {
        const response = await axiosInstance.get(`${baseRouteAdminInvoice}/check-is-admin/${id}`);
        return response.data;

    } catch (error) {
        throw new Error('Failed to check if admin');

    }
};


export const getOrganizationAddresses = async () => {
    try {
        const response = await axiosInstance.get(
            `${baseRouteAdminInvoice}/get-organization-address`,
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createOrganizationAddress = async (data) => {
    try {
        const response = await axiosInstance.post(
            `${baseRouteAdminInvoice}/create-organization-address`,
            data,
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const updateOrganizationAddress = async (data) => {

    try {
        const response = await axiosInstance.post(
            `${baseRouteAdminInvoice}/update-organization-address`,
            data,
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const deleteOrganizationAddress = async (id) => {
    try {

        const response = await axiosInstance.delete(
            `${baseRouteAdminInvoice}/delete-organization-address/${id}`,
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const setAddressAsDefault = async (data) => {

    try {
        const response = await axiosInstance.post(
            `${baseRouteAdminInvoice}/set-default-organization-address`,
            data
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const getAllCNCMaterialMaster = async () => {

    try {
        const response = await axiosInstance.get(
            `${baseRouteAdminInvoice}/get-all-master-material`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const createCncMasterMaterial = async (data) => {

    try {
        const response = await axiosInstance.post(
            `${baseRouteAdminInvoice}/upsert-master-material`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const deleteCncMasterMaterial = async (id) => {
    try {
        const response = await axiosInstance.delete(
            `${baseRouteAdminInvoice}/delete-master-material/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};





//change axios to axios instance in every request
